<template>
  <div class="emd-container _highlight_header no-border">
    <div class="emd-table-responsive">
      <table class="emd-table">
        <thead>
          <tr>
            <th>{{ $t('charge.detail.recipients.columns.installment') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.status') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.date') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.gross-amount') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.input') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.output') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.fees') }}</th>
            <th>{{ $t('charge.detail.recipients.columns.net-amount') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in rows"
            :key="index"
          >
            <td
              :data-label="$t('charge.detail.recipients.columns.installment')"
            >
              {{ item.installment }}
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.status')">
              <span
                class="emd-badge"
                v-bind:class="statusClass(item.status)"
                >{{ item.status }}</span
              >
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.date')">
              <div class="eu-flex eu-column">
                <span
                  v-if="item.original_payment_date"
                  class="scratched"
                >
                  {{ item.original_payment_date | dateFormat('date') }}
                </span>
                <span v-if="item.payment_date">
                  {{ item.payment_date | dateFormat('date') }}
                </span>
              </div>
            </td>
            <td
              :data-label="$t('charge.detail.recipients.columns.gross-amount')"
            >
              {{
                formatValue(
                  item.gross_amount.value,
                  item.gross_amount.currency_symbol
                )
              }}
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.input')">
              <span class="emd-text _color_success">{{
                formatValue(item.input.value, item.input.currency_symbol)
              }}</span>
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.output')">
              <span class="emd-text _color_danger">{{
                formatValue(item.output.value, item.output.currency_symbol)
              }}</span>
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.fees')">
              <span
                :class="`emd-text ${
                  item.fees.value > 0 ? '_color_success' : '_color_danger'
                }`"
                >{{
                  formatValue(item.fees.value, item.fees.currency_symbol)
                }}</span
              >
            </td>
            <td :data-label="$t('charge.detail.recipients.columns.net-amount')">
              <span class="emd-text _color_info">{{
                formatValue(
                  item.net_amount.value,
                  item.net_amount.currency_symbol
                )
              }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { statusClass } from '@/filters'
export default {
  name: 'TransactionRecipientInstallments',
  data () {
    return {
      statusClass: statusClass
    }
  },
  props: {
    rows: {
      type: [Array, Object],
      default: () => [],
      required: true
    },
    formatValue: {
      type: Function,
      required: true
    }
  }
}
</script>
<style scoped>
.no-border {
  border: none;
}
.scratched {
  text-decoration: line-through;
}
._color_black {
  background-color: var(--color-black);
  color: var(--color-white);
}
._color_purple {
  background-color: var(--color-purple-bg);
  color: var(--color-purple);
}
</style>
